import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import classes from "./CreateNewRole.module.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../../components/Common/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import {
  checkRoleNameActionHandler,
  createRoleActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/rolesAndPermissionsActionHandler";
import { useDispatch } from "react-redux";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { FormattedMessage } from "react-intl";

const roleSchema = yup.object().shape({
  role: yup.string().required("Role is required"),
});

const CreateNewRole = ({ handleSearchQuery, setaddRoleModal }) => {
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: { role: "" },
    resolver: yupResolver(roleSchema),
  });
  const { handleSubmit, watch } = methods;
  const [nameErrorMsg, setNameErrorMsg] = useState("");
  const [isRoleNameExistLoader, setisRoleNameExistLoader] = useState(false);
  const [createRoleLoading, setcreateRoleLoading] = useState(false);
  const roleVal = watch("role");
  const [alphanumericCheckErrorMsg, setAlphanumericCheckErrorMsg] =
    useState("");

  const onSubmit = (data) => {
    setcreateRoleLoading(true);
    dispatch(createRoleActionHandler({ RoleName: data?.role })).then(
      (response) => {
        if (response.data) {
          setcreateRoleLoading(false);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Role Created Successfully")
          );
          handleSearchQuery();
          setaddRoleModal(false);
        } else
          dispatch(setErrorHandler(errorTypes.FAIL, "Role Creation Failed"));
      }
    );
  };

  const handleRole = (e) => {
    const val = e.target.value.trim() !== "" && e.target.value.trim();
    if (val) {
      const regex = new RegExp(/^[a-zA-Z0-9:_@#?|'`\][ ]*$/);
      if (!regex.test(val))
        setAlphanumericCheckErrorMsg(
          "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
        );
      else {
        setAlphanumericCheckErrorMsg("");

        setisRoleNameExistLoader(true);
        dispatch(checkRoleNameActionHandler(val)).then((response) => {
          if (response && response.status === 200) {
            setisRoleNameExistLoader(false);
            if (response.data) {
              setNameErrorMsg("Role Name already exists");
            } else {
              setNameErrorMsg("");
            }
          }
        });
      }
    } else {
      setAlphanumericCheckErrorMsg("Please enter Role Name");
      setNameErrorMsg("");
      setisRoleNameExistLoader(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.createNewRole}>
        <div className={classes.textField}>
          <Input
            label={<FormattedMessage id="NEW_ROLE" />}
            name="role"
            fieldName="role"
            placeholder="Enter Role"
            labelColor="light"
            required
            maxLength="300"
            width="40"
            onChange={(e) => handleRole(e)}
            loading={isRoleNameExistLoader}
          />
        </div>
        {nameErrorMsg &&
          !isRoleNameExistLoader &&
          !alphanumericCheckErrorMsg &&
          roleVal && <div className={classes.errorMessage}>{nameErrorMsg}</div>}
        {alphanumericCheckErrorMsg && !isRoleNameExistLoader && roleVal && (
          <div className={classes.errorMessage}>
            {alphanumericCheckErrorMsg}
          </div>
        )}

        <div className={classes.btn}>
          <Button
            type="submit"
            label={<FormattedMessage id="SAVE_TXT" />}
            small
            dark
            backgroundColor={createRoleLoading ? undefined : "#D31B61"}
            loading={createRoleLoading}
            disabled={
              !roleVal ||
              nameErrorMsg ||
              isRoleNameExistLoader ||
              alphanumericCheckErrorMsg
                ? true
                : false
            }
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default React.memo(CreateNewRole);
